export * from './sidebar.directive';



// WEBPACK FOOTER //
// /home/ubuntu/JointlyWebService/admin/CollabspaceAdminPortal/src/app/directives/sidebar/index.ts